
import { Station } from './Station';
import { StationGroup } from './StationGroup';
import { StationSet } from './StationSet';

export class StationSelection {

  stationGroup: StationGroup;
  stationSet: StationSet;
  station: Station;
  valid: boolean;

}
